<h1 mat-dialog-title>Detalle del dia</h1>

<mat-dialog-content>
  <mat-accordion>
    @for (worklog of worklogs; track worklog; let i = $index) {
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ worklog.started_at | date: 'medium' }}
          </mat-panel-title>
          <mat-panel-description class="worklog-panel-description">
            <span>{{ worklog.duration_in_seconds_real | secondsToStringTime }}</span>
            @if (getWorklogLocation(worklog); as location) {
              <button
                mat-icon-button
                [matTooltip]="'Ver ubicación: ' + location.name"
                type="button"
                (click)="openLocationDialog(worklog); $event.stopPropagation()"
              >
                <mat-icon>fmd_good</mat-icon>
              </button>
            }
          </mat-panel-description>
        </mat-expansion-panel-header>
        <p>{{ worklog.description }}</p>
        <p>
          Creado el: <i>{{ worklog.created_at | date: 'long' }}</i>
        </p>
        @if (worklog.is_task_related) {
          <button mat-flat-button color="accent" type="button" style="margin-right: 10px" (click)="goToTaskFromWorklog(worklog)">
            Ir a la tarea
          </button>
        }
        @if (worklog.can_delete) {
          <button mat-flat-button color="warn" type="button" (click)="delete(i)">Eliminar registro</button>
        }
      </mat-expansion-panel>
    }
  </mat-accordion>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button color="accent" (click)="onNoClick()" cdkFocusInitial type="button">Cerrar</button>
</mat-dialog-actions>
